import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=3f6ea5de&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&id=3f6ea5de&lang=less&scoped=true&"
import style1 from "./detail.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6ea5de",
  null
  
)

export default component.exports